import React, { PureComponent, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';

import { IProps } from './types/box-header';
import style from './box-header.pcss';

class BoxHeader extends PureComponent<IProps> {

    cn = classNames.bind(style);

    render(): ReactNode {
        const props = {
            'className' : this.cn('box-header', this.props.className),
            'data-count': this.props.count,
            'children'  : (
                <strong
                    className={this.cn('box-header__children')}
                >
                    {this.props.children}
                </strong>
            )
        };

        if(this.props.to) {
            return <Link to={this.props.to} {...props} />;
        }

        return <h6 {...props} />;
    }

}

export default BoxHeader;
